import { DiagramDefinition } from "../types";

export const m003Definition: DiagramDefinition = {
  id: "M-003",
  title: "Route Access Rules & Middleware Lifecycle",
  description:
    "Execution pipeline of an HTTP request passing through Helmet, Rate Limiter, Router Matcher, Bearer Token Auth, Security Rule Macro Evaluator, and finally querying the SQLite database.",
  viewBox: "0 0 840 220",
  nodes: [
    { id: "Client", kind: "client", label: "Client Request", subtext: "GET /api/...", position: [80, 60], size: [120, 48] },
    { id: "Helmet", kind: "service", label: "1. Helmet & CORS", subtext: "Security Headers", position: [280, 60], size: [150, 48] },
    { id: "RateLimit", kind: "service", label: "2. Rate Limiter", subtext: "Check IP Limits", position: [480, 60], size: [140, 48] },
    { id: "Router", kind: "service", label: "3. Router Matcher", subtext: "Find Route", position: [680, 60], size: [140, 48] },
    
    // Bottom row (snaking backwards from right to left)
    { id: "Auth", kind: "service", label: "4. JWT Auth", subtext: "Populate req.auth", position: [680, 160], size: [140, 48] },
    { id: "Rules", kind: "service", label: "5. Rule Engine", subtext: "Evaluate Macros", position: [480, 160], size: [140, 48] },
    { id: "DB", kind: "database", label: "6. SQLite DB", subtext: "Query Execution", position: [280, 160], size: [150, 48] },
    { id: "Success", kind: "status", label: "200 OK Response", subtext: "JSON Payload", position: [80, 160], size: [135, 48], statusColor: "#22c55e" },
  ],
  edges: [
    { id: "e1", source: "Client", target: "Helmet", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "Helmet", target: "RateLimit", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "RateLimit", target: "Router", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "Router", target: "Auth", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e5", source: "Auth", target: "Rules", sourcePort: "left", targetPort: "right", routing: "straight" },
    { id: "e6", source: "Rules", target: "DB", sourcePort: "left", targetPort: "right", routing: "straight" },
    { id: "e7", source: "DB", target: "Success", sourcePort: "left", targetPort: "right", routing: "straight", animated: true },
  ],
};
